export const FONTS = {
  REGULAR: "Noor-Regular",
  BOLD: "Noor-Bold",
  LIGHT: "Noor-Light",
};
